import * as React from 'react';
const FibromialgiaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="m137.67 117.57-9.36-4.36M71.47 86.69l-9.14-4.26M129.39 129.39l-8.13-8.13M78.54 78.54l-7.93-7.93M117.57 137.67l-4.38-9.41M86.68 71.43l-4.25-9.1"
      className="prefix__cls-1"
    />
    <path
      d="M87.51 95.17c1.21-1.34 2.5-2.69 3.84-4.03 6.69-6.69 13.6-11.98 19.59-15.33"
      className="prefix__cls-2"
    />
    <path
      d="M81.24 102.74c-2.17 2.91-3.98 5.73-5.42 8.36"
      className="prefix__cls-1"
    />
    <path
      d="M88.7 123.99c6.07-3.31 13.13-8.7 19.95-15.53 6.69-6.69 12-13.6 15.33-19.59M80.11 115.4c4.23-5.16 10.17-11.66 17-18.48 6.69-6.69 13.08-12.54 18.19-16.75M119.64 84.52c-2.01 2.43-4.41 5.16-7.07 8.07"
      className="prefix__cls-2"
    />
    <path
      d="M84.39 119.69c5.16-4.25 11.67-10.19 18.5-17.01 1-1 1.99-1.99 2.96-2.97"
      className="prefix__cls-1"
    />
    <path
      d="m69.45 137.55 4.77-4.77c1.99-1.99 4.75-3.09 7.54-2.84 9.18.82 21.91-4.96 32.67-15.72 10.76-10.74 16.54-23.48 15.72-32.66-.26-2.81.85-5.55 2.84-7.54l4.56-4.56M62.45 130.71l4.62-4.62c2.04-2.04 3.14-4.88 2.82-7.77-.98-9.18 4.8-22.08 15.68-32.95 10.87-10.87 23.77-16.67 32.97-15.69 2.87.31 5.71-.78 7.77-2.82l4.41-4.41"
      className="prefix__cls-2"
    />
  </svg>
);
export default FibromialgiaIcon;
